import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, BookmarkCheck, Coins, CalendarClock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, StatCard, Panel, EmptyState } from "@/components/common";
import LeadCard from "@/components/LeadCard";
import { useAuth } from "@/context/AuthContext";
import { api, fmtDate } from "@/lib/api";

export default function Dashboard() {
  const { user } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/agency/dashboard").then((r) => setD(r.data));
  }, []);

  const sub = d?.subscription;
  return (
    <div>
      <PageHeader eyebrow="Overview" title={`Hello, ${user.name?.split(" ")[0] || "there"}`} subtitle="Your pipeline of verified business leads at a glance."
        actions={<Button asChild data-testid="browse-marketplace-button"><Link to="/app/marketplace">Browse leads<ArrowRight className="h-4 w-4 ml-2" /></Link></Button>} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <StatCard label="Available leads" value={d?.available_leads ?? "—"} icon={Store} testId="stat-available-leads" />
        <StatCard label="Unlocked leads" value={d?.unlocked_leads ?? "—"} icon={BookmarkCheck} tone="emerald" testId="stat-unlocked-leads" delay={60} />
        <StatCard label="Credit balance" value={d?.credit_balance ?? "—"} icon={Coins} tone="amber" testId="stat-credit-balance" delay={120}
          hint={d && d.credit_balance < 5 ? "Running low — top up in Billing" : undefined} />
        <StatCard label="Subscription" value={sub ? sub.plan_name : "None"} icon={CalendarClock} tone="sky" testId="stat-subscription" delay={180}
          hint={sub ? `Expires ${fmtDate(sub.end_at)}` : "Subscribe for unlimited contacts"} />
      </div>
      {d?.pending_payments > 0 && (
        <div className="mt-6 rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 text-sm" data-testid="pending-payments-banner">
          You have {d.pending_payments} payment request(s) awaiting admin verification.
        </div>
      )}
      <Panel title="Latest verified leads" className="mt-8" actions={<Link to="/app/marketplace" className="text-sm text-primary hover:underline">View all</Link>}>
        {d && d.recent_leads.length === 0 ? (
          <EmptyState title="No leads yet" text="New verified leads will appear here." />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
            {(d?.recent_leads || []).map((l, i) => <LeadCard key={l.id} lead={l} delay={i * 50} />)}
          </div>
        )}
      </Panel>
    </div>
  );
}
